jQuery(document).ready(($) => {
    if ($('#js-carousel-product').length > 0) {
        if ($('#js-carousel-product li').length < 5) {
            $('.module-product #nav-carousel-product-prev i').addClass('hide-on-desktop');
            $('.module-product #nav-carousel-product-next i').addClass('hide-on-desktop');
        }

        $('#js-carousel-product').slick({
            infinite: true,
            slidesToShow: 4,
            autoplay: false,
            prevArrow: '#nav-carousel-product-prev',
            nextArrow: '#nav-carousel-product-next',
            centerMode: true,
            lazyLoad: 'ondemand',
            rows: 0,

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    if ($('#js-carousel-howto').length > 0) {
        $('#js-carousel-howto').slick({
            infinite: true,
            slidesToShow: 3,
            autoplay: false,
            arrows: false,
            lazyLoad: 'ondemand',
            rows: 0,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    },
                },
            ],
        });
    }

    // single-ps_product.php
    if ($('#product-bottles').length > 0 && $('#no-template-pager').length > 0) {
        $('#product-bottles').slick({
            infinite: true,
            slidesToShow: 1,
            autoplay: false,
            arrows: false,
            speed: 200,
            asNavFor: '#no-template-pager',
            rows: 0,
        });
        $('#no-template-pager').slick({
            infinite: false,
            autoplay: false,
            arrows: false,
            speed: 200,
            asNavFor: '#product-bottles',
            variableWidth: true,
            focusOnSelect: true,
            slidesToShow: 7,
            slidesToScroll: 7,
            centerMode: true,
            centerPadding: '10px',
            rows: 0,
        });

        $('#no-template-pager .slick-slide').keydown(function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                const index = $(this).attr('data-slick-index');
                $('#product-bottles').slick('slickGoTo', index);
            }
        });
    }

    if ($('#js-managed-content-love-notes').length > 0) {
        $('#js-managed-content-love-notes').slick({
            infinite: true,
            slidesToShow: 1,
            autoplay: false,
            prevArrow: '#js-managed-content-love-notes-prev',
            nextArrow: '#js-managed-content-love-notes-next',
            rows: 0,
            speed: 150,
        });
    }

    const $window = $(window);
    const $body = $('body');

    const fixPager = function () {
        const limit = 48 * parseFloat($body.css('font-size'));
        if ($window.width() < limit) {
            const height = $('.cyclone-slide-image:visible').height();
            $('.cycle-pager:visible').css('top', height);
        }
    };
    $window.resize(fixPager);
    $(document).on('carousel-initialized', fixPager);
});
